import {
    Box,
    Button,
    Link,
    Stack,
    Typography
} from '@mui/material'
import { useRouteError } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Header } from './header';
import { Footer } from './footer';

export default function Error() {
    const { t } = useTranslation('error');
    const navigate = useNavigate();
    const error = useRouteError();

    console.log(error);

    const handleBack = () => {
        navigate('/')
    }
    
    return (
        <Box 
            sx={{
            minHeight: {
                sm: "100vh"
            },
            display: "flex",
            flexDirection: "column",
            justifyContent: {
                xs: "flex-start",
                sm: "center", 
            },
            alignItems: "center",
            px: 2,
            pt: {
                xs: 2,
                sm: 0,
            },
            pb: {
                xs: 2,
                sm: 0,
            }
        }}>
            <Box
                sx={{
                p: 2,
                bgcolor: "white",
                borderRadius: 2,
                boxShadow: 3,
                width: {
                    xs: "100%",
                    sm: "780px",
                },
                maxWidth: "780px",
                height: "auto",
                overflow: "hidden",
                }}
            >
                <Stack spacing={2}
                       alignItems="center"
                       textAlign="center"
                >
                    <Header/>

                    <Typography variant='overline' fontWeight='bold' sx={{ fontSize: '16px' }}>
                        {t('errorTitle')}
                    </Typography>
            
                    <Typography variant='subtitle1'>
                        {t('errorMessage')}
                    </Typography>

                    <Link href="mailto:support@servetechpr.com" underline="none">support@servetechpr.com</Link>

                    <Button variant="contained" onClick={handleBack}>
                        {t('errorGoBackButton')}
                    </Button>

                    <Footer/>
                </Stack>                                
            </Box>
        </Box>
    )
}